import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const Rate = ({ count, rating, color, onRating, isHover, size }) => {
    const [hoverRating, setHoverRating] = useState(0);

    const getColor = (index) => {
        if (hoverRating >= index) {
            return color.filled;
        } else if (!hoverRating && rating >= index) {
            return color.filled;
        }

        return color.unfilled;
    };

    const starRating = useMemo(() => {
        return Array(count)
            .fill(0)
            .map((_, i) => i + 1)
            .map((idx) => (
                <i
                    className="bx bxs-star"
                    key={idx}
                    onClick={() => onRating(idx)}
                    style={{
                        color: getColor(idx),
                        cursor: 'pointer',
                        fontSize: `${size}px`,
                    }}
                    onMouseEnter={() => {
                        isHover && setHoverRating(idx);
                    }}
                    onMouseLeave={() => {
                        isHover && setHoverRating(0);
                    }}
                ></i>
            ));
    }, [count, rating, hoverRating]);

    return <div>{starRating}</div>;
};

Rate.propTypes = {
    count: PropTypes.number,
    rating: PropTypes.number,
    onRating: PropTypes.func,
    // color: {
    //     filled: PropTypes.string,
    //     unfilled: PropsTypes.string,
    // },
};

Rate.defaultProps = {
    count: 5,
    rating: 0,
    color: {
        filled: '#f5eb3b',
        unfilled: '#DCDCDC',
    },
    isHover: false,
};

export default Rate;
